module.exports = __webpack_public_path__ + "img/Trims.587559f9.png";